// Styles have been copied to packages/editor/generative-ai-modal/examples/utils/components/Modals.tsx
// Updates to this file should also be copied to there.
import { css } from '@emotion/react';
export const styleDiv = css`
  position: relative;
  align-items: center;
  display: flex;
  justify-content: center;
`;
export const styleBorder = css`
  position: absolute;
  left: 0px;
  top: 0px;
  right: 0;
  bottom: 0;
`;